import React, { FC, ReactNode } from 'react';

import cn from 'classnames';

import css from './title.css';

interface TitleProps {
    children: ReactNode;
    className?: string;
}

const Title: FC<React.PropsWithChildren<TitleProps>> = (props) => {
    const totalClasses = cn(css.root, props.className);
    return <h3 className={totalClasses}>{props.children}</h3>;
};

export default Title;
